import * as Sentry from '@sentry/react'

import { SENTRY_DNS } from 'UTILS/constants'

/*
const consoleWarn = console.warn
console.warn = function (...args) {
  Sentry.captureMessage('Console Warning', {
    level: 'warning',
    extra: { args },
  })
  consoleWarn.apply(console, args)
}
*/

Sentry.init({
  dsn: SENTRY_DNS,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.breadcrumbsIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  profilesSampleRate: 1.0,
  tracePropagationTargets: [/^\/(api|auth|oauth2)\//],
})

import('@sentry-internal/replay')
  .then(({ replayIntegration }) => {
    Sentry.addIntegration(replayIntegration())
  })
  .catch(() => undefined)
